const imageTimeStamp = (image) => {
  let timestamp = new Date().getTime();
  return `${image}?t=${timestamp}`;
};

export default imageTimeStamp;
